module.exports = __webpack_public_path__ + "static/img/查看回复参数.2219585.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Doc/assets/imgs/查看回复参数.png
// module id = BzJ5
// module chunks = 0